var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DIV",
    { staticClass: "container ml-0 mr-auto" },
    [
      _c(
        "ItpWidgetCard",
        [
          _c(
            "ItpBox",
            { attrs: { slot: "header", alignItems: "center" }, slot: "header" },
            [
              _c("strong", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("pgettext")(
                        "Meter Consumptions",
                        "MeterConsumptions"
                      )
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("ItpButton", {
                staticClass: "ml-auto",
                attrs: {
                  text: _vm._f("pgettext")(
                    "Add consumption...",
                    "MeterConsumptions"
                  ),
                  variant: "light",
                  size: "sm"
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_8320016629450276_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.loaded
            ? _c(
                "BListGroup",
                [
                  !_vm.items.length
                    ? _c("BListGroupItem", [
                        _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("pgettext")(
                                  "No consumptions.",
                                  "MeterConsumptions"
                                )
                              ) +
                              "\n        "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.items, function(item) {
                    return _c(
                      "BListGroupItem",
                      { key: item.id, staticClass: "d-flex flex-column" },
                      [
                        _c(
                          "ItpBox",
                          { attrs: { alignItems: "start" } },
                          [
                            _c(
                              "ItpBox",
                              {
                                staticClass: "w-100",
                                attrs: { direction: "column" }
                              },
                              [
                                _c(
                                  "ItpBox",
                                  { staticClass: "W-100" },
                                  [
                                    _c(
                                      "ItpBox",
                                      {
                                        staticClass: "col-md-2",
                                        attrs: { direction: "column" }
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm._f("date")(item.start.date)
                                              ) +
                                              "\n                "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("small", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm._f("number")(
                                                  item.start.reading
                                                )
                                              ) +
                                              " " +
                                              _vm._s(item.unit) +
                                              "\n                "
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ItpBox",
                                      {
                                        staticClass: "col-md-2",
                                        attrs: { direction: "column" }
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm._f("date")(item.end.date)
                                              ) +
                                              "\n                "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("small", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm._f("number")(
                                                  item.end.reading
                                                )
                                              ) +
                                              " " +
                                              _vm._s(item.unit) +
                                              "\n                "
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ItpBox",
                                      {
                                        staticClass: "col-md-2",
                                        attrs: { direction: "column" }
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm._f("number")(
                                                  item.total_consumption
                                                )
                                              ) +
                                              " " +
                                              _vm._s(item.unit) +
                                              "\n                "
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "ItpBox",
                                      {
                                        staticClass: "col-md-2",
                                        attrs: {
                                          alignItems: "center",
                                          direction: "column"
                                        }
                                      },
                                      [
                                        item.billing_factor
                                          ? _c(
                                              "ItpBadge",
                                              {
                                                staticClass: "mx-3",
                                                attrs: {
                                                  title: _vm._f("gettext")(
                                                    "Billing factor"
                                                  ),
                                                  "no-box-shadow": "",
                                                  variant: "light"
                                                }
                                              },
                                              [
                                                _c("ItpIcon", {
                                                  attrs: { name: "fa-times" }
                                                }),
                                                _vm._v(" "),
                                                _c("ItpText", {
                                                  attrs: {
                                                    text: item.billing_factor
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.non_billable
                                          ? _c("ItpBadge", {
                                              staticClass: "mx-3 mt-2",
                                              attrs: {
                                                variant: "warning",
                                                text: _vm._f("pgettext")(
                                                  "Non billable",
                                                  "RentalService"
                                                ),
                                                "no-box-shadow": ""
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    item.meter
                                      ? _c(
                                          "ItpBox",
                                          {
                                            staticClass: "col-md-2",
                                            attrs: {
                                              alignItems: "start",
                                              "wrap-items": ""
                                            }
                                          },
                                          [
                                            _c("UcCompactMeterDisplay", {
                                              staticClass: "pl-3",
                                              attrs: { payload: item.meter }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "ItpBox",
                                      {
                                        staticClass: "col-md-2",
                                        attrs: {
                                          direction: "column",
                                          alignItems: "start",
                                          "wrap-items": ""
                                        }
                                      },
                                      [
                                        item.consumer
                                          ? _c("UcCompactCompanyDisplay", {
                                              staticClass: "pl-3",
                                              attrs: { payload: item.consumer }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("UcCompactRentalDisplay", {
                                          staticClass: "pl-3",
                                          attrs: { payload: item.rental }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("ItpBox", [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-7" },
                                    [
                                      item.note
                                        ? _c("ItpText", {
                                            attrs: { text: item.note, pre: "" }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("ItpButton", {
                              staticClass: "ml-auto",
                              attrs: {
                                icon: "fa-pen",
                                tooltip: _vm._f("gettext")("Edit"),
                                variant: "light",
                                size: "sm"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.evh_8497951412896552_clickPreventStop(
                                    $event,
                                    { item: item }
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }